const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname === "[::1]"
);

const ODONTOFLOW_BUILD_VERSION = "20260528-pwa-cache-v1";
const ODONTOFLOW_UPDATE_RELOAD_KEY = "odontoflow_update_reload_" + ODONTOFLOW_BUILD_VERSION;

function reloadOnceForUpdate() {
  try {
    if (window.sessionStorage.getItem(ODONTOFLOW_UPDATE_RELOAD_KEY) === "1") return;
    window.sessionStorage.setItem(ODONTOFLOW_UPDATE_RELOAD_KEY, "1");
  } catch {
    // continuar aunque sessionStorage no esté disponible
  }

  window.location.reload();
}

function activateWaitingWorker(registration) {
  if (!registration?.waiting) return;

  try {
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
  } catch {
    // si el SW no escucha mensajes, controllerchange igual cubrirá instalaciones nuevas
  }
}

export function register() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  let refreshing = false;

  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    reloadOnceForUpdate();
  });

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
      return;
    }

    registerValidSW(swUrl);
  });
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (registration.waiting) {
        console.info("OdontoFlow encontró una versión lista. Actualizando...");
        activateWaitingWorker(registration);
      }

      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) return;

        installingWorker.onstatechange = () => {
          if (installingWorker.state !== "installed") return;

          if (navigator.serviceWorker.controller) {
            console.info("OdontoFlow actualizó la app. Recargando versión nueva...");
            activateWaitingWorker(registration);
          } else {
            console.info("OdontoFlow instalado para acceso rápido.");
          }
        };
      };
    })
    .catch((error) => {
      console.warn("No se pudo registrar el service worker de OdontoFlow.", error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, {
    headers: { "Service-Worker": "script" },
    cache: "no-store"
  })
    .then((response) => {
      const contentType = response.headers.get("content-type") || "";

      if (response.status === 404 || !contentType.includes("javascript")) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
        return;
      }

      registerValidSW(swUrl);
    })
    .catch(() => {
      console.info("OdontoFlow se está ejecutando sin service worker en localhost.");
    });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.warn("No se pudo desregistrar el service worker.", error));
}

export { ODONTOFLOW_BUILD_VERSION };
